import gmail from '../images/icons/gmail.png';
import linkedin from '../images/icons/linkedin.png';
import github from '../images/icons/github.png';

export const icons = [
  {
    href:
      'https://mail.google.com/mail/?view=cm&amp;fs=1&amp;tf=1&amp;to=david.holy.ko@gmail.com',
    src: gmail,
  },
  { href: 'https://github.com/davidholyko', src: github },
  { href: 'https://www.linkedin.com/in/davidhko1', src: linkedin },
];



// WEBPACK FOOTER //
// ./src/data/ContactData.js